<template>
  <transition name="fade">
    <div v-show="show" class="company-root">
      <div class="bgs">
        <div :style="bg5Style" class="bg bg5"></div>
        <div :style="bg6Style" class="bg bg6"></div>
      </div>

      <div class="texts">
        <div class="text text1">
          <dl>
            <dt :style="text1TitleStyle">
              <blur-image
                width="38"
                height="57"
                url="/images/company/text1-1@2x.png"
              ></blur-image>
            </dt>
            <dd :style="text1ContentStyle">
              <blur-image
                width="38"
                height="100"
                url="/images/company/text1-2@2x.png"
                :px="blurPixel"
              ></blur-image>
            </dd>
          </dl>
        </div>

        <div :style="text2Style" class="text text2">
          <dl>
            <dt>
              <blur-image
                width="13"
                height="71"
                url="/images/company/text2-1@2x.png"
              ></blur-image>
            </dt>
            <dd>
              <blur-image
                width="83"
                height="339"
                url="/images/company/text2-2@2x.png"
              ></blur-image>
            </dd>
          </dl>
        </div>

        <div class="text text3">
          <dl>
            <dt :style="text3TitleStyle">
              <blur-image
                width="13"
                height="71"
                url="/images/company/text3-1@2x.png"
              ></blur-image>
            </dt>
            <dd :style="text3ContentStyle">
              <blur-image
                width="83"
                height="339"
                url="/images/company/text3-2@2x.png"
                :px="blurPixel"
              ></blur-image>
            </dd>
          </dl>
        </div>

        <div :style="text45Style" class="text text4">
          <dl>
            <dt>
              <blur-image
                width="36"
                height="71"
                url="/images/company/text4-1@2x.png"
              ></blur-image>
            </dt>
            <dd>
              <blur-image
                width="151"
                height="287"
                url="/images/company/text4-2@2x.png"
              ></blur-image>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { fadeStyle, transformStyle, blurPixel } from '../../lib/styleGenerator'

export default {
  name: 'pageCompany',

  computed: {
    blurPixel() {
      return blurPixel(this.scrollRate)
    },
    show() {
      const currentPage = this.$store.getters.currentPage

      return currentPage === 'company'
    },

    scrollRate() {
      return this.$store.getters.companyPageRate
    },

    text1TitleStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 50 })
      }
    },

    text1ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: -70, scale: 3 }),
        ...fadeStyle(this.scrollRate, 2)
      }
    },

    text2Style() {
      return {
        ...transformStyle(this.scrollRate, { y: 100 })
      }
    },

    text3TitleStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 100 })
      }
    },

    text3ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: -50, scale: 0.5 }),
        ...fadeStyle(this.scrollRate, 2, 0.2)
      }
    },

    text45Style() {
      return {
        ...transformStyle(this.scrollRate, { y: 100 })
      }
    },

    bg5Style() {
      return {
        ...transformStyle(this.scrollRate, { x: 200 })
      }
    },

    bg6Style() {
      return {
        ...transformStyle(this.scrollRate, { y: -200 }),
        ...fadeStyle(this.scrollRate, 4)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.company-root
  position: relative

.texts
  position: absolute
  width: 400px
  height: 600px
  top: 70px
  left: 80px
  font-size: 14px
  letter-spacing: 2.5px
  .text
    position: absolute
    dl
      position: relative
      dt, dd
        display: inline-block
        position: absolute
      dt
        height: 90px
        vertical-align: top
        top: 0
        right: 0
      dd
        margin-top: 50px
        top: 120px
        right: 0

    &.text1
      top: 0
      right: 0

    &.text2
      top: 0
      right: 57px

    &.text3
      top: 50px
      right: 157px

    &.text4
      top: 100px
      right: 257px

    &.text5
      top: 100px
      right: 280px

.bg
  position: absolute
  background-size: cover
  height: 510px
  width: 340px
  overflow: hidden
  &5
    right: 50px
    top: 202px
    background-image: url('/images/bg/bg5.jpg')
  &6
    right: 260px
    top: 70px
    background-image: url('/images/bg/bg6.jpg')

.edge
  .text
    dd
      transform-origin: 90% 80%
</style>
